import styled from 'styled-components';
import { Box, theme } from '@capitalise/ui-design-system';

const CircleBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => {
    theme.sizes[size];
  }};
  height: ${({ size }) => {
    theme.sizes[size];
  }};
  border-radius: 50%;
`;

export default CircleBox;
